import { SubmitButton, TextComponent } from "../../../../components";
import styles from "./RsvpGuestInvitation.module.css";
import { Col, Layout, Row } from "antd";
import Header from "../../../../components/header/Header";
import { RsvpIcon } from "../../../../components/icons/Icons";
import { useState } from "react";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { useSelector } from "react-redux";

const options = [
  { title: "Joyfully Accept" },
  { title: "Regretfully Decline" },
];

const CoreIcon = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23 11.5C16.56 11.5 11.5 16.56 11.5 23C11.5 29.44 16.56 34.5 23 34.5C29.44 34.5 34.5 29.44 34.5 23C34.5 16.56 29.44 11.5 23 11.5ZM23 0C10.35 0 0 10.35 0 23C0 35.65 10.35 46 23 46C35.65 46 46 35.65 46 23C46 10.35 35.65 0 23 0ZM23 41.4C12.88 41.4 4.6 33.12 4.6 23C4.6 12.88 12.88 4.6 23 4.6C33.12 4.6 41.4 12.88 41.4 23C41.4 33.12 33.12 41.4 23 41.4Z"
        fill={color}
      />
    </svg>
  );
};

const RsvpGuestInvitation = () => {
  const [selectedValue, setSelectedValue] = useState(options[0].title);
  const navigate = useNavigate();
  const { height, width } = useWindowDimensions();
  const { state } = useLocation();
  return (
    <div className={styles.mainContainer}>
      <Layout className="site-layout">
        <Header
          mainHeader={styles.headerColor}
          isProfile={true}
          title={"RSVP"}
          style={{ padding: 0, background: "var(--white-color)", height: 85 }}
          onBackClick={() => navigate(-1)}
        />
      </Layout>
      <Row className={styles.mainRow}>
        <Col xs={24} sm={24} md={16} lg={12} xl={9}>
          <div className={styles.mainContent}>
            <TextComponent textClass={styles.heading}>
              Invitation Request
            </TextComponent>
            <TextComponent textClass={styles.snippet}>
              Will you be able to Join us at our wedding? Please confirm your
              availability
            </TextComponent>
            <Row className={styles.col}>
              {options.map((option) => (
                <SubmitButton
                  btnClass={`${styles.btnClass1} ${
                    selectedValue === option.title && styles.selectedBtn
                  }`}
                  title={
                    <Row className={styles.btnContent}>
                      <CoreIcon
                        color={
                          selectedValue === option.title
                            ? "var(--primary-color)"
                            : "#000"
                        }
                      />{" "}
                      {option.title}
                    </Row>
                  }
                  onClick={() => setSelectedValue(option.title)}
                />
              ))}
            </Row>
            <div className={styles.footer}>
              <BiSolidChevronRightCircle
                className={styles.con1}
                size={30}
                onClick={() =>
                  navigate("/rsvp/rsvpGuestWishing", {
                    state: { ...state, option: selectedValue },
                  })
                }
              />
            </div>
          </div>
        </Col>
      </Row>
      <div className={styles.bigIcon}>
        <RsvpIcon size={width > 1199 ? 750 : width > 575 ? 570 : 350} />
      </div>
      <div className={styles.smallIcon}>
        <RsvpIcon
          size={width > 1199 ? 400 : 250}
          className={styles.smallRsvpIcon}
        />
      </div>
    </div>
  );
};

export default RsvpGuestInvitation;
